import React, { memo } from 'react';
import { Text, Conditional, ConfirmModal } from '@cashfree-intl/coherent';
import { titleCase } from 'utils/common';
import {
  ACTIVATE_REFUND_WALLET,
  DEACTIVATE_REFUND_WALLET,
} from 'containers/Wallets/constants';
import { IWalletStateChangeConfirmation } from 'containers/Wallets/types';

function WalletStateChangeConfirmation({
  activeModal,
  walletType,
  closeModal,
  handleModalConfirmation,
}: IWalletStateChangeConfirmation) {
  return (
    <>
      <Conditional if={activeModal === ACTIVATE_REFUND_WALLET}>
        <ConfirmModal
          title={`Activate ${titleCase(walletType)} Wallet`}
          confirmText="Yes, Activate"
          onClose={closeModal}
          onConfirm={handleModalConfirmation}
          confirmBtnEvent={`Primary_Button_Activate_${titleCase(
            walletType,
          )}_Wallet_Confirm`}
          closeBtnEvent={`Link_Button_Activate_${titleCase(
            walletType,
          )}_Wallet_Cancel`}
          closeCrossEvent={`Activate_${titleCase(
            walletType,
          )}_Wallet_Icon_Close`}
        >
          <Text variant="b14" color="bodyLight" className="mb-1">
            If you choose to activate {walletType} wallet, all your refunds will
            be moved to the wallet and you need to keep your wallet recharged
            otherwise your refunds will be put on hold.
          </Text>
          <Text variant="b14" color="bodyLight">
            Are you sure you want to activate {walletType} wallet?
          </Text>
        </ConfirmModal>
      </Conditional>
      <Conditional if={activeModal === DEACTIVATE_REFUND_WALLET}>
        <ConfirmModal
          title={`Deactivate ${titleCase(walletType)} Walllet`}
          confirmText="Yes, Deactivate"
          onClose={closeModal}
          onConfirm={handleModalConfirmation}
          confirmBtnEvent={`Primary_Button_Deactivate_${titleCase(
            walletType,
          )}_Wallet_Confirm`}
          closeBtnEvent={`Link_Button_Deactivate_${titleCase(
            walletType,
          )}_Wallet_Cancel`}
          closeCrossEvent={`Deactivate_${titleCase(
            walletType,
          )}_Wallet_Icon_Close`}
        >
          <Text variant="b14" color="bodyLight" className="mb-2">
            If you choose to deactivate {walletType} wallet, all your refunds
            will be moved to the unsettled balance.
          </Text>
          <Text variant="b14" color="bodyLight">
            Are you sure you want to deactivate {walletType} wallet?
          </Text>
        </ConfirmModal>
      </Conditional>
    </>
  );
}

export default memo(WalletStateChangeConfirmation);
